import React, { Suspense } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import img from './images/bg.png';
import Model from '../../../model';
import './index.sass';
import { observer } from 'mobx-react-lite';
import { datetimeFromUTC } from 'utils/dayjs';
import { closestEventData } from 'api/events';
import { Skeleton } from '@mui/material';

const { block, el } = bem('buy-consultation-widget');
const BuyConsultationWidget = () => {
    const { modal, events } = Model;
    // const { date, time } = datetimeFromUTC(closestEvent);
    return (
        <div className={block()} onClick={modal.openOrderForm}>
            <div className={el('photo')}>
                <TeaserPhoto img={img} />
            </div>
            <div className={el('bottom-block')}>
                <div className={el('text')}>
                    <Text serif>Запишитесь на консультацию</Text>
                </div>
                <div className={el('icon')}>
                    <Icon name={'caret-right'} />
                </div>
            </div>
            <Suspense fallback={<ClosestEventSkeleton />}>
                <ClosestEvent resource={closestEventData} />
            </Suspense>
        </div>
    )
}

const ClosestEvent = ({resource}) => {
    const { closestEvent, error } = resource.read();
    if (error) { return null; }
    const { date, time } = datetimeFromUTC(closestEvent);
    return (
        <div className={ el('closest-event') }>
            <div className={ el('closest-event-label') }>
                <Text>Ближайшая запись</Text>
            </div>
            <div className={ el('closest-event-value') }>
                <Text>{ `${ date } ${ time }` }</Text>
            </div>
        </div>
    )
}

const ClosestEventSkeleton = () => {
    return (
        <div className={ el('closest-event') }>
            <div className={ el('closest-event-label') }>
                <Text>Ближайшая запись</Text>
            </div>
            <div className={ el('closest-event-value') }>
                <Skeleton />
            </div>
        </div>
    )
}

export default observer(BuyConsultationWidget);
